<template>
  <aside class="comments display-flex flex-column border-radius ">
    <div class="flex-grow comments__timeline padding-normal">
      <InfiniteLoading
        ref="infiniteLoading"
        direction="top"
        @infinite="loadMore"
      >
        <div slot="spinner">
          <BIcon spin>
            <BRefreshIcon class="font-size-xhuge" />
          </BIcon>
        </div>
        
        <div slot="no-more">
          <p>Esses são todos os comentários.</p> 
        </div>

        <div slot="no-results">
          <p v-if="!hasComments">Não existem comentários ainda.</p>
        </div>
      </InfiniteLoading>

      <slot></slot>
    </div>

    <footer>
      <BInputWithButton
        name="comment"
        ref="inputWithButton"
        @clicked="value => $emit('submit', value)"
        :inputClasses="
          'font-size-big padding-normal border border-white-darker-4 border-focus-ink-lighter-1 bg-focus-white-base bg-white-base'
        "
        :buttonClasses="
          'padding-normal border border-white-darker-4 bg-white-base'
        "
        placeholder="Digite aqui seu comentário"
        :disabled="isLoading"
      >
        <BIcon>
          <BSendIcon class="font-size-xxbig blue-darker-1" />
        </BIcon>
      </BInputWithButton>
    </footer>
  </aside>
</template>

<script>
import {
  BIcon,
  BSendIcon,
  BRefreshIcon,
  BInputWithButton,
} from '@bossabox-code/design-system'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'Comments',
  components: {
    BIcon,
    BSendIcon,
    BRefreshIcon,
    InfiniteLoading,
    BInputWithButton,
  },
  props: {
    inputValue: {
      type: String,
      default: '',
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    hasComments: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    loadMore($state) {
      this.state = $state
      this.$emit('list')
    },
  },
  watch: {
    inputValue() {
      this.$refs.inputWithButton.clean()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@bossabox-code/design-system/css/_variables.scss';

.comments {
  &__timeline {
    &::-webkit-scrollbar {
      width: 0.6em;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px map-get($colors, 'white-darker-4');
    }

    &::-webkit-scrollbar-thumb {
      background-color: map-get($colors, 'ink-lighter-2');
    }

    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: scroll;
    background-color: map-get($colors, 'white-darker-2');

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
